import {
	AbstractControl,
	ValidationErrors,
	ValidatorFn,
	Validators,
} from '@angular/forms';

function validateEmails(emails: string) {
	return (
		emails
			.split(',')
			.map((email) =>
				Validators.email({ value: email.trim() } as AbstractControl),
			)
			.find((_) => _ !== null) === undefined
	);
}

export function multipleEmailsValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		if (
			control.value === '' ||
			!control.value ||
			validateEmails(control.value)
		) {
			return null;
		}

		return { multipleEmails: true };
	};
}
